<template>
    <div class="header">
        <div class="logOutButton">
            <Button icon="pi pi-arrow-circle-left" :label="isStatement() ? 'Zamknij kartę' : 'Powrót'" @click="goBack"/>
            <Button icon="pi pi-power-off logout" label="Wyloguj się" @click="signOut"/>
        </div>
        <div class="mobileMenu">
            <Menubar :model="items"/>
        </div>
    </div>
</template>

<script>
import Button from 'primevue/button';
import PanelMenu from 'primevue/panelmenu';
import Menubar from 'primevue/menubar';
import ConfirmDialog from 'primevue/confirmdialog'
import {getMenuItems, authStore} from "../../../core/api";

export default {
    name: 'Header',
    components: {
        Button,
        ConfirmDialog,
        PanelMenu,
        Menubar
    },
    data() {
        return {
            items: null,
            goBackLabel: 'Powrót'
        }
    },
    methods: {
        signOut: function () {
            this.$confirm.require({
                message: 'Czy chcesz się wylogować?',
                header: 'Wylogowanie',
                icon: 'pi pi-power-off',
                accept: () => {
                    this.$router.push('/login')
                    localStorage.removeItem('token');
                    authStore.data.isAuthenticated = false;
                    authStore.data.menuCategories = [];
                },
                reject: () => {

                }
            });
        },

        getSignOutOption: function () {
            return {
                label: 'Wyloguj się',
                icon: 'pi pi-fw pi-power-off',
                items: [
                    {
                        label: 'Wyloguj',
                        icon: 'pi pi-fw pi-power-off',
                        command: () => {
                            this.signOut();
                        }
                    }
                ]
            };
        },

        isStatement: function () {
            return window.location.pathname.includes('statement');
        },

        goBack: function () {
            if(this.isStatement()) {
                window.close('', '_parent');
            } else {
                this.$router.go(-1);
            }
        }
    },
    mounted() {
        this.items = getMenuItems(this.$router);
        this.items = [...this.items, this.getSignOutOption()];
    }
}
</script>

<style lang="scss">
@import "@core/scss";

div.header {
    background-color: #ddd;
    height: 55px;

    @media print {
        display: none;
    }

    & > div.logOutButton {
        text-align: right;
        padding: 10px;
        display: none;

        @include respond-to(768plus) {
            display: flex;
            justify-content: space-between;
        }
    }

    & > div.mobileMenu {
        display: block;

        @include respond-to(768plus) {
            display: none;
        }
    }
}

div.p-menubar {
    justify-content: flex-end;
}

</style>
